import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects';
import {getChatConversations} from "@api/chat";
import {
  FETCH_APPEND_CONVERSATIONS, FETCH_APPEND_CONVERSATIONS_FAILED, FETCH_APPEND_CONVERSATIONS_SUCCESS,
  FETCH_CONVERSATIONS,
  FETCH_CONVERSATIONS_FAILED,
  FETCH_CONVERSATIONS_SUCCESS
} from "@iso/redux/chat/actions";

export function* fetchChatConversations(action) {
  const response = yield call(getChatConversations, action.payload);

  try {
    yield put({
      type: FETCH_CONVERSATIONS_SUCCESS,
      payload: response?.data?.data,
    });
  } catch (error) {
    yield put({
      type: FETCH_CONVERSATIONS_FAILED,
      payload: error,
    });
  }
}

export function* fetchMoreChatConversations(action) {
  const response = yield call(getChatConversations, action.payload);

  try {
    yield put({
      type: FETCH_APPEND_CONVERSATIONS_SUCCESS,
      payload: response?.data?.data,
    });
  } catch (error) {
    yield put({
      type: FETCH_APPEND_CONVERSATIONS_FAILED,
      payload: error,
    });
  }
}

export default function* rootSaga() {
  yield all(
    [
      yield takeLatest(FETCH_CONVERSATIONS, fetchChatConversations),
      yield takeEvery(FETCH_APPEND_CONVERSATIONS, fetchMoreChatConversations)
    ]
  )
}